import React from 'react';
import { Database } from 'lucide-react';

const EmptyState = ({ 
  message = "No records available", 
  icon: Icon = Database,
  subMessage = "",
  className = ""
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
      <div className="rounded-full bg-gray-100 p-4 mb-4">
        <Icon size={32} className="text-gray-400" />
      </div>
      <p className="text-gray-600 font-medium text-sm">{message}</p>
      {subMessage && <p className="text-gray-400 text-xs mt-1">{subMessage}</p>}
    </div>
  );
};

export default EmptyState;
